import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  selectWrapper: css`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
  `,
  select: css`
    z-index: 1000;
    min-width: 280px;
    width: 100%;

    & > div {
      overflow: unset;
    }
  `,
  endIcon: css`
    display: flex;
    align-items: center;
    gap: 5px;
  `,
  editIconButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
